import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import DepartureLocationsList from 'components/DepartureLocationsList';

import { withData } from 'lib';
import { SettingsDepartureLocationListPageQuery } from '__generated__/SettingsDepartureLocationListPageQuery.graphql';

const query = graphql`
  query SettingsDepartureLocationListPageQuery {
    ...DepartureLocationsList_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsDepartureLocationListPageQuery>;
};

const SettingsDepartureLocationListPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<SettingsDepartureLocationListPageQuery>(
    query,
    preloadedQuery
  );

  return (
    <Page
      breadcrumbs={[
        { link: '/settings', name: 'Nustatymai' },
        { name: 'Išvykimo vietos' },
      ]}>
      <DepartureLocationsList data={data} />
    </Page>
  );
};

export default withData<SettingsDepartureLocationListPageQuery>({
  query,
})(SettingsDepartureLocationListPage);
